import { render, staticRenderFns } from "./AgreementTemplate.vue?vue&type=template&id=8a6bde78&scoped=true&"
import script from "./AgreementTemplate.vue?vue&type=script&lang=js&"
export * from "./AgreementTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AgreementTemplate.vue?vue&type=style&index=0&id=8a6bde78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6bde78",
  null
  
)

export default component.exports